<template>
  <section>
    <div class="initial">
        <Adsense
          data-ad-client="ca-pub-8143206471999291"
          data-ad-slot="4822082380">
        </Adsense>
        <div class="columns">
          <div class="column main_bar is-8">
            <h1>『{{this.$route.params.id}}』の夢占い一覧</h1>
            <p>（{{this.initials[0].contents.length}}件）</p>
            <div class="initial_list" v-for="initial in this.initials[0].contents" :key="initial.id">
              <router-link :to="{name:'article', params:{ id: initial.title}}"><li>{{initial.title}}</li></router-link>
              <hr class="initial_list_border">
            </div>
            <Adsense
              data-ad-client="ca-pub-8143206471999291"
              data-ad-slot="2195919044">
            </Adsense>
          </div>
          <div class="column side_bar">
            <div class="search_keyword">
            <p>キーワード検索</p>
            <SearchComponent/>
            </div>
            <h2>よく見る夢</h2>
            <ThemesComponent/>
            <h2>50音順</h2>
            <InitialComponent />
            <h2>カテゴリー</h2>
            <CategoryComponentCategory/>
            <div class="side_ad">
              <Adsense
                data-ad-client="ca-pub-8143206471999291"
                data-ad-slot="3701076989">
              </Adsense>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import store from '@/store';
import SearchComponent from '@/components/SearchComponent'
import InitialComponent from '@/components/InitialComponent.vue'
import CategoryComponentCategory from '@/components/CategoryComponentCategory'
import ThemesComponent from '@/components/ThemesComponent.vue'
export default {
  components: {
    SearchComponent,
    InitialComponent,
    CategoryComponentCategory,
    ThemesComponent
  },
  data() {
    return {
      initials:  []
    };
  },
  watch: {
    '$route' (to) {
        store.commit('start');
        this.$router.go(to.params.id)
    }
  },
  created() {
        store.commit('start')
        let url = "https://dream.microcms.io/api/v1/article?filters=initial[equals]" + this.$route.params.id + "&limit=1000"
        axios
            .get(url, {
            headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
            })
            .then(res => {
              console.log(res.data)
              if(res.data.totalCount != 0){
                this.initials.push(res.data)
                //かな順に並び替えするメソッド
                this.sortedItemsByName()
                store.commit('end');
              }
            }).then(()=>{
                const title = "「" + this.$route.params.id + "」" + "の夢占い・夢診断・夢解釈｜夢占い辞典ゆめみん"
                const description = "「" + this.$route.params.id+ "」"  + "の夢占い一覧"
                const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
                const og_image = 'https://dream.ameneko.com/topImage.jpeg'
                document.title = title
                document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
                document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
                document.querySelector("meta[property='og:title']").setAttribute('content', title)
                document.querySelector("meta[name='description']").setAttribute('content', description)
                document.querySelector("meta[property='og:description']").setAttribute('content', description)                
            .catch(err => {
                console.log(err);
                store.commit('end');
            });
        });
  },
  methods:{
    sortedItemsByName(){
        var vm = this
        vm.initials[0].contents.sort((a, b) => {
          return (a.spelling < b.spelling) ? -1 : (a.spelling > b.spelling) ? 1 : 0;
        });
    }
  }
}
</script>

<style scoped>
.initial{
  padding:20px;
}
h1{
  font-weight: bold;
  font-size: 1.5em;
  border-bottom: solid 2px #27556A;
}
h2{
  font-weight: bold;
  font-size: 1.2em;
  border-bottom: solid 2px #27556A;
  margin: 20px 0 20px 0;
}
.initial_list{
  font-size: 1.1em;
  padding: 5px 0 5px 16px;
}
.initial_list_border{
  margin: 4px 4px 4px 0;
  border:none;
  border-top:dashed 1px #e8e8e8;
  height:1px;
  color:#FFFFFF;
}
li{
  position: relative;
  list-style-type: none;
}
li::after {
  display: block;
  content: '';
  position: absolute;
  top: .5em;
  left: -1em;
  width: 6px;
  height: 6px;
  border-right: 1px solid #666;
  border-bottom: 1px solid #666;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.search_keyword{
  margin: 0px 0px 30px 0px;
}
.main_bar{
  margin: 0 5px 0 5px;
}
.side_bar{
  margin: 0 5px 0 5px;
}
.side_ad{
  margin: 20px 0 0 0;
}
</style>